import { DatePipe, NgStyle } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { JobModel } from 'src/app/models/job.model';
import {
  PrepareScheduleTaskFilter,
  ScheduleTaskFilter,
} from 'src/app/models/scheduleTask-filter.model';
import { SupplierModel } from 'src/app/models/supplier.model';
import { TaskGruopModel } from 'src/app/models/task-group.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { WorkTaskService } from 'src/app/services/work-task.service';
import { taskStatuses } from 'src/assets/data/task-statuses';
import { UserModel } from 'src/app/models/user.model';
import { UserManagementService } from 'src/app/services/user-management.service';
import { ScheduleUserFilterService } from 'src/app/services/schedule-user-filter.service';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { ToastService } from 'src/app/services/toast.service';
import { MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import { Guid } from 'guid-typescript';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductModel } from 'src/app/models/products';
import { ProductService } from 'src/app/services/product.service';
import { MultiSelectModel } from 'src/app/shared/models/multi-select.model';
import { MultiselectAutocompleteComponent } from 'src/app/shared/components/multiselect-autocomplete/multiselect-autocomplete.component';
import { ScheduleDatesFilterModel } from 'src/app/models/filter-date.model';
import { DatesFilterComponent } from '../../dates-filter/dates-filter.component';
import { PointOfSaleModel } from 'src/app/models/pointOfSale.model';
import { WorkloadsService } from 'src/app/services/workloads.service';
import { SharedServices } from 'src/app/shared/services/shared.service';
import { UserService } from 'src/app/shared/services/user.service';
import { TagService } from 'src/app/services/tag.service';
import { TagModel } from 'src/app/models/tag.model';
import { TagUpdateService } from '../../../services/tag-update.service';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect, MatOption, MatOptgroup } from '@angular/material/select';
import { MatChipGrid, MatChipInput, MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MultiselectAutocompleteComponent as MultiselectAutocompleteComponent_1 } from '../../../shared/components/multiselect-autocomplete/multiselect-autocomplete.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
@Component({
    selector: 'app-schedule-tasks-filter',
    templateUrl: './schedule-tasks-filter.component.html',
    styleUrls: ['./schedule-tasks-filter.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatCard, MatButton, MatCardContent, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatIcon, MatExpansionPanelTitle, MatFormField, MatLabel, MatSelect, MatOption, MatOptgroup, MatChipGrid, MatChipInput, MatChipListbox, MatChipOption, MultiselectAutocompleteComponent_1, DatesFilterComponent, MatCheckbox, MatRadioGroup, MatRadioButton, NgStyle, MatSlideToggle, MatInput]
})
export class ScheduleTasksFilterComponent implements OnInit, AfterViewInit {
  private readonly tagUpdateService = inject(TagUpdateService);
  private readonly workTaskSvc = inject(WorkTaskService);
  private readonly supplierSrv = inject(SupplierService);
  private readonly userSvc = inject(UserManagementService);
  usrSvc = inject(UserService);
  datepipe = inject(DatePipe);
  toastr = inject(ToastService);
  private readonly scheduleUserFilterSrv = inject(ScheduleUserFilterService);
  private readonly productSrv = inject(ProductService);
  private readonly workloadSvc = inject(WorkloadsService);
  private readonly sharedServices = inject(SharedServices);
  private readonly tagSrv = inject(TagService);


  subscription: Subscription | undefined;
  private franchiseSubscription: Subscription | undefined;

  panelOpenState = '';
  @Output() filterEvent = new EventEmitter<PrepareScheduleTaskFilter>();
  @Output() appliedFilter = new EventEmitter();
  @Input() visibility: boolean = false;
  @Input() onlyPendingContacTasks: boolean = false;
  @Input() showCanceledTasks: boolean = false;
  @Input() showPostponedTasks: boolean = false;
  @Input() onlyBudgetedTasks: boolean = false;
  @ViewChild('contractorComponent', { static: false })
  contractorMultiselect!: MultiselectAutocompleteComponent;
  @ViewChild('ignoredContractorComponent', { static: false })
  ignoredContractorMultiselect!: MultiselectAutocompleteComponent;
  @ViewChild('productComponent', { static: false })
  productMultiselect!: MultiselectAutocompleteComponent;
  @ViewChild('sealesPointsComponent', { static: false })
  sealesPointsMultiselect!: MultiselectAutocompleteComponent;
  @ViewChild(DatesFilterComponent, { static: false })
  datesFilterComponent!: DatesFilterComponent;

  taskGroups: TaskGruopModel[] = [];
  grouping: any[] = [];
  contractors: MultiSelectModel[] = [];
  // Own option objects: the multiselect marks the selection on them, and ignoring a contractor must not select it in
  // the "Prestador" filter.
  ignoredContractorOptions: MultiSelectModel[] = [];
  products: MultiSelectModel[] = [];
  sealesPoints: MultiSelectModel[] = [];
  selectedContractor: boolean = false;
  selectedContractorName: string = '';
  taskStatuses: any[] = taskStatuses;
  selectedStatuses: number[] = [];
  selectedFilterValue: any = null;
  toShow: string[] = [];
  clients: string[] = [];
  tags: TagModel[] = [];
  selectedTags: TagModel[] = [];

  selectedfilterId = new UntypedFormGroup({
    id: new UntypedFormControl(null),
  });

  searchText!: string;
  creatorNames!: UserModel[];
  selectedOwners: string[] = [];
  selectedOwnersNames: string[] = [];
  scheduleUserfilters: ScheduleTaskFilter[] = [];

  addFilter = false;
  saveFilter = false;
  finishedEmitEvent: boolean = false;

  isVisible: boolean = true;

  // The filter survives leaving and coming back to the calendar (sessionStorage, per tab and per user, so a
  // different user logging in on the same tab never gets it). It is restored once every option list is loaded,
  // because the selection is rebuilt from those lists.
  static readonly storageKeyPrefix = 'tupi.schedule.filter';
  private static readonly optionLists = 6; // points of sale, contractors, products, creators, tags, task groups
  private pendingRestore: any = null;
  private optionListsLoaded = 0;
  // While a kept filter waits to be restored the calendar is not loaded: the restore loads it, so it is fetched once.
  private loadDeferred = false;
  onlyContactForm = new UntypedFormGroup({
    onlycontact: new FormControl(false),
  });

  onlyBudgetedForm = new UntypedFormGroup({
    onlyBudgeted: new FormControl(false),
  });

  canceledTasksForm = new UntypedFormGroup({
    canceledTasks: new FormControl(false),
  });

  postponedForm = new UntypedFormGroup({
    postponedTasks: new FormControl(false),
  });

  prepareFilter = new UntypedFormGroup({
    id: new UntypedFormControl(null),
    groupType: new UntypedFormControl([]),
    taskType: new UntypedFormControl([]),
    clientName: new UntypedFormControl([]),
    creationDateFrom: new UntypedFormControl(null),
    creationDateTo: new UntypedFormControl(null),
    contractors: new UntypedFormControl([]),
    ignoredContractors: new UntypedFormControl([]),
    taskStatus: new UntypedFormControl([]),
    owner: new UntypedFormControl([]),
    isPaidLabor: new UntypedFormControl(null),
    products: new UntypedFormControl([]),
    sealesPoints: new UntypedFormControl([]),
    onlyHasPendingContact: new UntypedFormControl(null),
    includeCanceled: new UntypedFormControl(null),
    includePostponed: new UntypedFormControl(null),
    includeBudgeted: new UntypedFormControl(null),
    tags: new UntypedFormControl([]),
  });

  newFilter = new UntypedFormGroup({
    description: new UntypedFormControl(null, [Validators.required]),
  });

  readonly separatorKeysCodes: number[] = [13, 188];

  contractorSelectChange = (event: any) => {
    this.prepareFilter.controls.contractors.setValue(
      (event.data as MultiSelectModel[]).map(({ itemValue }) => itemValue)
    );
    this.checkSelectedFilterValue();
  };

  ignoredContractorSelectChange = (event: any) => {
    this.prepareFilter.controls.ignoredContractors.setValue(
      (event.data as MultiSelectModel[]).map(({ itemValue }) => itemValue)
    );
  };

  productsSelectChange = (event: any) => {
    this.prepareFilter.controls.products.setValue(
      (event.data as MultiSelectModel[]).map(({ itemValue }) => itemValue)
    );
    this.checkSelectedFilterValue();
  };

  sealesPointsSelectChange = (event: any) => {
    this.prepareFilter.controls.sealesPoints.setValue(
      (event.data as MultiSelectModel[]).map(({ itemValue }) => itemValue)
    );
    this.checkSelectedFilterValue();
  };

  ngOnInit(): void {
    this.pendingRestore = this.readStoredFilter();
    this.subscribeToTagUpdates(); // Suscríbete a actualizaciones
    this.getTags();
    this.schedulefilters();
    this.taskStatuses = this.taskStatuses
      .filter((x) => x.code != 'Cancelada')
      .sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
    this.getTaskGroups();
    this.getOwners();
    this.getContractors();
    this.getProducts();
    this.CleanUpFilter(true);
    this.getPointsOfSale();
    this.franchiseSubscription =
      this.sharedServices.selectedFranchise.subscribe((franchise) => {
        if (this.pendingRestore) {
          this.loadDeferred = true;
        } else if (!franchise) {
          this.CleanUpFilter();
        } else {
          this.filterSchedule();
        }
      });
    this.onlyContactForm.controls.onlycontact.patchValue(
      this.onlyPendingContacTasks
    );
    this.canceledTasksForm.controls.canceledTasks.patchValue(
      this.showCanceledTasks
    );
    this.postponedForm.controls.postponedTasks.patchValue(
      this.showPostponedTasks
    );
    this.onlyBudgetedForm.controls.onlyBudgeted.patchValue(
      this.onlyBudgetedTasks
    );
  }

  ngOnDestroy() {
    if (this.franchiseSubscription) {
      this.franchiseSubscription.unsubscribe();
    }
  }
  subscribeToTagUpdates() {
    this.tagUpdateService.tagsUpdated$.subscribe(() => {
      this.getTags(); // Vuelve a cargar las etiquetas cuando se notifique un cambio
    });
  }
  getPointsOfSale() {
    this.workloadSvc.getPointOfSales().subscribe({
      next: (data: PointOfSaleModel[]) => {
        data.forEach((d) => {
          this.sealesPoints.push({
            itemDescription: d.description,
            itemKey: d.id,
            selected: false,
            itemValue: d,
          });
        });
        this.optionListLoaded();
      },
      error: () => this.optionListFailed(),
    });
  }

  setPicker() {
    if (this.isVisible && this.datesFilterComponent) {
      this.datesFilterComponent.setPicker(
        new Date(this.prepareFilter.controls.creationDateFrom.value),
        new Date(this.prepareFilter.controls.creationDateTo.value)
      );
    }
  }

  setDates(dates: ScheduleDatesFilterModel) {
    if (dates.from == '' || dates.to == '') {
      this.prepareFilter.controls.creationDateFrom.reset();
      this.prepareFilter.controls.creationDateTo.reset();
    } else {
      this.prepareFilter.controls.creationDateFrom.patchValue(dates.from);
      this.prepareFilter.controls.creationDateTo.patchValue(dates.to);
    }

    this.searchText = '';
  }

  getContractors() {
    this.supplierSrv.getAll().subscribe({
      next: (data: SupplierModel[]) => {
        data.forEach((d) => {
          this.contractors.push({
            itemDescription: d.fullName,
            itemKey: d.id,
            selected: false,
            itemValue: d,
          });
          this.ignoredContractorOptions.push({
            itemDescription: d.fullName,
            itemKey: d.id,
            selected: false,
            itemValue: d,
          });
        });
        this.optionListLoaded();
      },
      error: () => this.optionListFailed(),
    });
  }

  getProducts() {
    this.productSrv.get().subscribe({
      next: (data: ProductModel[]) => {
        data.forEach((d) => {
          this.products.push({
            itemDescription: d.name,
            itemKey: d.id,
            selected: false,
            itemValue: d,
          });
        });
        this.optionListLoaded();
      },
      error: () => this.optionListFailed(),
    });
  }

  ngAfterViewInit() {
    this.initFilters();
  }

  openPopover() {
    // this.trigger?.openPopover();
  }

  getOwners() {
    this.userSvc.getUsers().subscribe({
      next: (data: UserModel[]) => {
        // Users without a role only tried to log in; they cannot create tasks (IA-2392).
        this.creatorNames = data.filter((user) => !!user.roleId);
        this.optionListLoaded();
      },
      error: () => this.optionListFailed(),
    });
  }

  getTags() {
    this.tagSrv.getTags().subscribe({
      next: (data) => {
        this.tags = data;
        this.optionListLoaded();
      },
      error: (err) => {
        this.toastr.error(
          'Etiquetas',
          'No se pudo obtener la lista etiquetas.'
        );
        this.optionListLoaded();
      },
    });
  }

  getTaskGroups() {
    this.workTaskSvc.getTaskGroups().subscribe({
      next: (data: TaskGruopModel[]) => {
        this.taskGroups = data;
        this.prepareFilter.controls.groupType.patchValue([]);
        this.optionListLoaded();
      },
      error: () => this.optionListFailed(),
    });
  }

  compareObjects(creator: any, selectedCreatorId: any): boolean {
    return creator.id === selectedCreatorId;
  }

  getJobs(groupId: any) {
    if (this.grouping.find((x) => x.groupId == groupId)) {
      let newGroup = this.grouping.filter((x) => x.groupId != groupId);

      let toRemove = this.grouping.find((x) => x.groupId == groupId).jobs;
      let jobList = this.prepareFilter.controls.taskType.value as string[];
      toRemove.forEach((x: JobModel) => {
        jobList = jobList.filter((j) => j != x.id.toString());
      });

      this.prepareFilter.controls.taskType.patchValue(jobList);
      this.grouping = newGroup;
    } else {
      this.workTaskSvc.getJobs(groupId).subscribe((data: JobModel[]) => {
        let groupname = this.taskGroups.find(
          (x) => x.id == Guid.parse(groupId)
        )?.description;

        this.grouping.push({
          groupId: groupId,
          groupName: groupname,
          jobs: data,
        });
      });
    }
    this.checkSelectedFilterValue();
  }

  emitToggleChange(toggleChangeEvent: MatSlideToggleChange) {
    const showCancel =
      typeof toggleChangeEvent == 'boolean'
        ? toggleChangeEvent
        : toggleChangeEvent.checked;

    this.prepareFilter.controls.includeCanceled.patchValue(showCancel);
    this.filterSchedule();
  }

  emitPendingContactToggleChange(toggleChangeEvent: MatSlideToggleChange) {
    const showPendingContact =
      typeof toggleChangeEvent == 'boolean'
        ? toggleChangeEvent
        : toggleChangeEvent.checked;
    this.prepareFilter.controls.onlyHasPendingContact.patchValue(
      showPendingContact
    );
    this.filterSchedule();
  }

  includePostponedToggleChange(toggleChangeEvent: MatSlideToggleChange) {
    const showPostponed =
      typeof toggleChangeEvent == 'boolean'
        ? toggleChangeEvent
        : toggleChangeEvent.checked;
    this.prepareFilter.controls.includePostponed.patchValue(showPostponed);
    this.filterSchedule();
  }

  includeBudgetedChange(toggleChangeEvent: MatSlideToggleChange) {
    const showBudgeted =
      typeof toggleChangeEvent == 'boolean'
        ? toggleChangeEvent
        : toggleChangeEvent.checked;
    this.prepareFilter.controls.includeBudgeted.patchValue(showBudgeted);
    this.filterSchedule();
  }

  filterSchedule(perDefault: boolean = false) {
    this.prepareFilter.controls.taskStatus.setValue(this.selectedStatuses);
    this.prepareFilter.controls.tags.setValue(this.selectedTags);
    this.prepareFilter.controls.owner.patchValue(this.selectedOwners);
    this.prepareFilter.controls.clientName.setValue(this.clients);
    let filterSchedule = this.prepareFilter.value as PrepareScheduleTaskFilter;

    if (this.isNewFilter()) {
      this.selectedFilterValue = null;
    }

    if (this.prepareFilter.valid) {
      this.filterEvent.emit(filterSchedule);
      this.storeFilter();
    }

    this.finishedEmitEvent = !perDefault;
  }

  selectStatus(item: any) {
    this.taskStatuses.find((x) => x.value == item.value).selected =
      !item.selected;
    if (item.selected) {
      this.selectedStatuses.push(Number(item.value));
    } else {
      this.selectedStatuses.forEach((i, index) => {
        if (i == item.value) this.selectedStatuses.splice(index, 1);
      });
    }
    this.checkSelectedFilterValue();
  }

  selectTag(item: TagModel, event: any) {
    if (event.checked) {
      this.selectedTags.push(item);
    } else {
      this.selectedTags.forEach((tag, index) => {
        if (tag.id == item.id) this.selectedTags.splice(index, 1);
      });
    }
    this.checkSelectedFilterValue();
  }

  checkSelectedTag(tagId: any) {
    if (this.selectedTags.find((x) => x.id == tagId)) {
      return true;
    }
    return false;
  }

  selectCreator(creator: UserModel) {
    let elem: string | undefined;
    elem = this.selectedOwners.find((x) => x == creator.id);
    if (elem == undefined) {
      this.selectedOwners.push(creator.id);
      this.selectedOwnersNames.push(creator.name);
    } else {
      this.selectedOwners.forEach((i, index) => {
        if (i == elem) {
          this.selectedOwners.splice(index, 1);
          this.selectedOwnersNames.splice(index, 1);
        }
      });
    }
    this.checkSelectedFilterValue();
  }

  CleanUpFilter(onlyClean: boolean = false) {
    this.prepareFilter.reset();
    this.prepareFilter.controls.groupType.setValue([]);
    this.prepareFilter.controls.taskType.setValue([]);
    this.prepareFilter.controls.contractors.setValue([]);
    this.prepareFilter.controls.ignoredContractors.setValue([]);
    this.prepareFilter.controls.products.setValue([]);
    this.prepareFilter.controls.sealesPoints.setValue([]);
    this.prepareFilter.controls.clientName.setValue([]);
    this.prepareFilter.controls.taskStatus.setValue([]);
    this.prepareFilter.controls.tags.setValue([]);
    this.selectedStatuses = [];
    this.selectedTags = [];
    this.taskStatuses.forEach((e) => {
      e.selected = false;
    });
    this.selectedOwners = [];
    this.selectedOwnersNames = [];
    this.selectedFilterValue = null;
    this.clients = [];
    if (this.contractorMultiselect) {
      this.contractorMultiselect.clenAllSelections();
    }
    if (this.ignoredContractorMultiselect) {
      this.ignoredContractorMultiselect.clenAllSelections();
    }
    if (this.productMultiselect) {
      this.productMultiselect.clenAllSelections();
    }
    if (this.sealesPointsMultiselect) {
      this.sealesPointsMultiselect.clenAllSelections();
    }
    this.onlyContactForm.reset();
    this.onlyBudgetedForm.reset();
    this.canceledTasksForm.reset();
    this.postponedForm.reset();
    this.clearSelectedfilterId();
    this.grouping = [];

    if (!onlyClean) {
      this.appliedFilter.emit(null);
      this.filterSchedule();
    }
  }

  schedulefilters() {
    this.scheduleUserFilterSrv.schedulefilters().subscribe((data) => {
      this.scheduleUserfilters = data;
    });
  }

  addSchedulefilters() {
    if (this.newFilter.valid && this.prepareFilter.controls != null) {
      this.prepareFilter.controls.owner.patchValue(this.selectedOwners);

      let prepareModel = this.prepareFilter.value as PrepareScheduleTaskFilter;
      let model = this.transformToScheduleTaskFilter(prepareModel);

      this.scheduleUserFilterSrv.addschedulefilters(model).subscribe(
        (data) => {
          this.selectedFilterValue = model;
          this.selectedfilterId.controls.id.setValue(data);
          this.schedulefilters();
          this.newFilter.reset();
          this.toastr.success('Filtro', 'El filtro se guardó correctamente.');
          this.initFilters();
        },
        (err) => {
          this.toastr.error('Filtro', 'El no se pudo guardar el nuevo filtro');
        }
      );
    } else {
      this.newFilter.controls.description.markAsTouched();
    }
  }

  transformToScheduleTaskFilter(
    input: PrepareScheduleTaskFilter
  ): ScheduleTaskFilter {
    return {
      id: input.id,
      from: input.from,
      to: input.to,
      description: this.newFilter.controls.description.value,
      clientName: input.clientName,
      creationDateFrom: input.creationDateFrom,
      creationDateTo: input.creationDateTo,
      groupType: input.groupType,
      owner: input.owner,
      taskStatus: input.taskStatus,
      tags: input.tags.map(({ id }) => id),
      taskType: input.taskType,
      isPaidLabor: input.isPaidLabor,
      contractor: input.contractors.map(({ id }) => id),
      productId: input.products.map(({ id }) => id),
      pointOfSaleId: input.sealesPoints.map(({ id }) => id),
    };
  }

  removeScheduleFilters(filterId: string) {
    this.selectedFilterValue = null;
    this.SwalFireQuestion().then((result) => {
      if (result.isConfirmed) {
        this.scheduleUserFilterSrv.removeschedulefilters(filterId).subscribe(
          (data) => {
            this.schedulefilters();
            this.CleanUpFilter();
            this.filterSchedule();
            this.toastr.success(
              'Filtro',
              'El filtro se eliminó correctamente.'
            );
          },
          (err) => {
            this.toastr.error('Filtro', 'El filtro no pudo ser eliminado');
          }
        );
      }
    });
  }

  selectedFilter(id: string) {
    this.finishedEmitEvent = false;
    if (this.selectedFilterValue) {
      this.selectedFilterValue.taskStatus.forEach((s: number) => {
        let statusItem = this.taskStatuses.find((x) => x.value == s);
        this.selectStatus(statusItem);
      });
    }

    this.selectedStatuses = [];
    let filter = this.scheduleUserfilters.find((x) => x.id == id);
    if (filter) {
      this.applyFilter(filter);
    }
  }

  private applyFilter(filter: ScheduleTaskFilter, toggles?: any, ignoredContractorIds: string[] = []) {
    this.CleanUpFilter(true);
    this.selectedFilterValue = filter;

    this.prepareFilter.patchValue(filter);
    if (toggles) {
      this.prepareFilter.patchValue(toggles);
      this.canceledTasksForm.controls.canceledTasks.patchValue(!!toggles.includeCanceled);
      this.onlyContactForm.controls.onlycontact.patchValue(!!toggles.onlyHasPendingContact);
      this.postponedForm.controls.postponedTasks.patchValue(!!toggles.includePostponed);
      this.onlyBudgetedForm.controls.onlyBudgeted.patchValue(!!toggles.includeBudgeted);
    }

    this.clients = [];
    filter.clientName.forEach((x) => {
      this.clients.push(x);
    });

    this.prepareFilter.controls.owner.patchValue(
      this.creatorNames.filter((x) => filter?.owner.includes(x.id))
    );
    this.selectedOwners = filter.owner;

    this.prepareFilter.controls.groupType.value.forEach((group: any) => {
      this.getJobs(group);
    });

    this.clearSelectedStatuses();

    filter.taskStatus.forEach((st) => {
      let statusItem = this.taskStatuses.find((x) => x.value == st);
      this.selectStatus(statusItem);
    });

    filter.tags.forEach((t) => {
      let tag = this.tags.find((x) => x.id == t);
      if (tag) {
        this.selectTag(tag, true);
      }
    });

    this.selectedfilterId.controls.id.setValue(filter.id);

    this.contractors.forEach((c) => {
      if (filter?.contractor.includes(c.itemKey)) {
        c.selected = true;
      }
    });

    this.prepareFilter.controls.contractors.setValue(
      this.contractors.filter((c) => c.selected).map((c) => c.itemValue)
    );

    this.products.forEach((c) => {
      if (filter?.productId.includes(c.itemKey)) {
        c.selected = true;
      }
    });

    this.sealesPoints.forEach((c) => {
      if (filter?.pointOfSaleId.includes(c.itemKey)) {
        c.selected = true;
      }
    });

    this.ignoredContractorOptions.forEach((c) => {
      c.selected = ignoredContractorIds.includes(c.itemKey);
    });
    this.prepareFilter.controls.ignoredContractors.setValue(
      this.ignoredContractorOptions.filter((c) => c.selected).map((c) => c.itemValue)
    );

    this.prepareFilter.controls.products.setValue(
      this.products.filter((c) => c.selected).map((c) => c.itemValue)
    );
    this.prepareFilter.controls.sealesPoints.setValue(
      this.sealesPoints.filter((c) => c.selected).map((c) => c.itemValue)
    );

    this.filterSchedule();
    this.initFilters();
  }

  isNewFilter() {
    if (this.selectedFilterValue) {
      let selected = this.selectedFilterValue as ScheduleTaskFilter;
      this.appliedFilter.emit(selected.description);
      return (
        selected.id != this.prepareFilter.controls.id.value ||
        selected.clientName != this.prepareFilter.controls.clientName.value ||
        !this.compareArray(
          selected.contractor,
          (
            this.prepareFilter.controls.contractors.value as SupplierModel[]
          ).map(({ id }) => id)
        ) ||
        selected.creationDateFrom !=
          this.prepareFilter.controls.creationDateFrom.value ||
        selected.creationDateTo !=
          this.prepareFilter.controls.creationDateTo.value ||
        selected.groupType != this.prepareFilter.controls.groupType.value ||
        !this.compareArray(
          selected.owner,
          this.prepareFilter.controls.owner.value
        ) ||
        !this.compareArray(
          selected.taskStatus,
          this.prepareFilter.controls.taskStatus.value
        ) ||
        !this.compareArray(
          selected.tags,
          this.prepareFilter.controls.tags.value
        ) ||
        selected.taskType != this.prepareFilter.controls.taskType.value
      );
    }
    return true;
  }

  clearSelectedStatuses() {
    this.taskStatuses.forEach((status: any) => {
      let statusItem = this.taskStatuses.find((x) => x.value == status.value);
      statusItem.selected = false;
    });
  }

  compareArray(firstArray: Array<any>, secondArray: Array<any>) {
    return (
      firstArray.length == secondArray.length &&
      firstArray.every(function (element, index) {
        return element === secondArray[index];
      })
    );
  }

  SwalFireQuestion(): Promise<SweetAlertResult> {
    return Swal.fire({
      title: 'Filtro',
      html: `<div class="swal2-content-custom">¿Desea eliminar el filtro seleccionado?</div>`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      confirmButtonColor: '#E61414',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#FFF',
      customClass: {
        title: 'swal2-title-custom',
        popup: 'swal2-popup-custom',
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom',
        actions: 'swal2-actions-custom',
      },
      reverseButtons: true,
    });
  }

  closePopover() {
    // this.trigger?.togglePopover();
  }

  checkPanelState(filter: string) {
    this.panelOpenState == filter
      ? (this.panelOpenState = '')
      : (this.panelOpenState = this.panelOpenState);
  }

  getButton(panel: string) {
    return this.panelOpenState != panel ? 'add' : 'remove';
  }

  checkSelectedFilterValue() {
    if (this.selectedFilterValue && this.finishedEmitEvent) {
      this.selectedFilterValue = null;
      this.finishedEmitEvent = false;
      this.clearSelectedfilterId();
    }
  }

  private optionListLoaded() {
    this.optionListsLoaded++;
    if (this.optionListsLoaded !== ScheduleTasksFilterComponent.optionLists || !this.pendingRestore) return;

    const stored = this.pendingRestore;
    // After the current turn: with cached lists this runs inside ngOnInit, and the initial franchise subscription
    // would then clean the filter again (and its empty request could answer last).
    setTimeout(() => {
      this.pendingRestore = null;
      const saved = stored.savedId ? this.scheduleUserfilters.find((x) => x.id == stored.savedId) : undefined;
      const ignoredContractorIds: string[] = stored.ignoredContractor ?? [];
      if (saved) {
        this.applyFilter(saved, stored.toggles, ignoredContractorIds);
      } else if (stored.filter) {
        this.applyFilter(stored.filter, stored.toggles, ignoredContractorIds);
      } else {
        this.loadDeferredCalendar();
      }
      this.loadDeferred = false;
    });
  }

  // A list the selection is rebuilt from could not be loaded: give up the restore and load the calendar unfiltered.
  private optionListFailed() {
    if (!this.pendingRestore) return;
    this.pendingRestore = null;
    this.loadDeferredCalendar();
  }

  private loadDeferredCalendar() {
    if (!this.loadDeferred) return;
    this.loadDeferred = false;
    this.CleanUpFilter();
  }

  private storageKey(): string | null {
    const userId = this.usrSvc.user?.sub;
    return userId ? `${ScheduleTasksFilterComponent.storageKeyPrefix}:${userId}` : null;
  }

  private readStoredFilter(): any {
    try {
      const key = this.storageKey();
      const raw = key ? sessionStorage.getItem(key) : null;
      const stored = raw ? JSON.parse(raw) : null;
      // An empty filter is what the calendar loads anyway: restoring it would only fetch everything twice.
      return stored && !this.isEmptyStoredFilter(stored) ? stored : null;
    } catch {
      return null;
    }
  }

  private isEmptyStoredFilter(stored: any): boolean {
    const hasValue = (v: any) => (Array.isArray(v) ? v.length > 0 : v !== null && v !== undefined && v !== '');
    return (
      !stored.savedId &&
      !(stored.ignoredContractor?.length > 0) &&
      !Object.values(stored.toggles ?? {}).some(Boolean) &&
      !Object.entries(stored.filter ?? {}).some(([key, value]) => key !== 'description' && hasValue(value))
    );
  }

  private storeFilter() {
    if (this.pendingRestore) return; // do not overwrite the filter that is still waiting to be restored
    const key = this.storageKey();
    if (!key) return; // unknown user: never share a filter between users
    try {
      const value = this.prepareFilter.value as PrepareScheduleTaskFilter;
      const stored = {
        filter: this.transformToScheduleTaskFilter({ ...value, owner: this.selectedOwners }),
        toggles: {
          includeCanceled: value.includeCanceled,
          onlyHasPendingContact: value.onlyHasPendingContact,
          includePostponed: value.includePostponed,
          includeBudgeted: value.includeBudgeted,
        },
        savedId: this.selectedfilterId.controls.id.value,
        ignoredContractor: (value.ignoredContractors ?? []).map(({ id }) => id),
      };
      // An empty filter is what the calendar loads anyway: keeping it would only make the next visit restore it.
      if (this.isEmptyStoredFilter(stored)) {
        sessionStorage.removeItem(key);
      } else {
        sessionStorage.setItem(key, JSON.stringify(stored));
      }
    } catch {
      // storage unavailable (private mode, quota): the filter is just not remembered
    }
  }

  clearSelectedfilterId() {
    this.selectedfilterId.controls.id.setValue(null);
    this.selectedFilterValue = null;
  }

  initFilters() {
    this.panelOpenState = '';
    this.addFilter = false;
    this.saveFilter = false;
  }

  hasFilterToSave() {
    return (
      this.prepareFilter.controls.clientName.value.length > 0 ||
      this.prepareFilter.controls.contractors.value.length > 0 ||
      this.prepareFilter.controls.creationDateTo.value != null ||
      this.prepareFilter.controls.creationDateFrom.value != null ||
      this.prepareFilter.controls.groupType.value.length > 0 ||
      this.prepareFilter.controls.isPaidLabor.value != null ||
      this.prepareFilter.controls.owner.value.length > 0 ||
      this.prepareFilter.controls.products.value.length > 0 ||
      this.prepareFilter.controls.sealesPoints.value.length > 0 ||
      this.prepareFilter.controls.taskStatus.value.length > 0 ||
      this.prepareFilter.controls.tags.value.length > 0 ||
      this.prepareFilter.controls.taskType.value.length > 0
    );
  }

  add(event: any): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.clients.push(value.trim());
    }

    if (input) {
      input.value = '';
    }

    this.clearSelectedfilterId();
  }

  remove(chip: string): void {
    const index = this.clients.indexOf(chip);

    if (index >= 0) {
      this.clients.splice(index, 1);
    }

    this.clearSelectedfilterId();
  }
}
